import * as zod from 'zod';

export const WeldConnectionOptions = zod.object({
  hostname: zod.string().default(''),
  port: zod.number().default(502),
});

export type WeldConnectionOptions = zod.infer<typeof WeldConnectionOptions>;
